import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {useTranslation} from 'react-i18next';
import ContractTableComponent from '../../Generic/ContractTableComponent';
import type {ContractListItem} from '../../../types/contract';

interface ViewContractDialogProps {
    open: boolean;
    contract: ContractListItem | null;
    onClose: () => void;
}

const noopPageChange = async (): Promise<void> => {
};

const ViewContractDialog: React.FC<ViewContractDialogProps> = ({open, contract, onClose}) => {
    const {t} = useTranslation();

    return (
        <Dialog open={open} onClose={() => {
        }} disableEscapeKeyDown maxWidth={false} PaperProps={{sx: {width: {xs: 'calc(100% - 32px)', sm: '600px'}, margin: 'auto'}}}>
            <DialogTitle>{t('employee.contract.dialog.viewTitle')}</DialogTitle>
            <DialogContent>
                <Box sx={{mt: 2}}>
                    <ContractTableComponent
                        selectedEmployeeContract={contract}
                        contractsPage={0}
                        contractsTotalRecords={contract ? 1 : 0}
                        onContractsPageChange={noopPageChange}
                        sx={{width: '100%'}}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" color="primary">
                    {t('common.actions.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewContractDialog;
